import moment from "moment";

// Un pedido con el complemento PSW (complementoPSWPedidos) trae la orden de
// compra del cliente y su fecha de vigencia. El pedido sirve todo el dia de su
// vigencia y queda vencido al dia siguiente.
//
// Sin el complemento activo, o sin fecha capturada, nunca se considera vencido.
//
// Es la misma regla que el semaforo de la tabla
// (TableItemDinamico.obtenerClaseSemaforoVigencia, diasRestantes < 0), para que
// la fila roja y el bloqueo siempre coincidan.
const pedidoVigenciaVencida = (pedido, complementoPSWPedidos) => {
    if (!complementoPSWPedidos) return false;
    if (!pedido?.fechaVigencia) return false;
    return moment(pedido.fechaVigencia)
        .startOf("day")
        .isBefore(moment().startOf("day"));
};

export default pedidoVigenciaVencida;
